import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import * as screenTypes from '../../../../constants/ScreenTypes';
import {saveData, restoreDefaultValues, cancelChanged} from '../actions/Screen';
import {
    disableNewTabBtn,
    createNewTab,
    changePicDesign
} from '../derivatives/TreeDesign/actions/Screen';
import {selectScrollField, isMovementsPanelShown} from '../actions/Screen';
import {getLastLevelFields} from '../../Common/actions/Screen';
import {activeCodes} from '../../../../constants/FieldConsts';
import {textConst, texts, getLocalizedText} from '../../../../constants/TextConst';
import {Checkbox} from 'semantic-ui-react';
import {Button} from '../../../../components/Common/Buttons/Button';
import Search from '../../../../components/Common/Search';
import Movements from '../../../../components/Common/Movements';
import DesignActionsMenu from './DesignMenu';
import List from '../../../../components/Common/List';
import {CollapsibleField} from '../../../../components/Common/Collapsible';
import DesignField from './DesignField';
import checkMark from '../../../../images/check_mark.png';

class DesignBottom extends Component<any, any> {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDefaults = this.handleDefaults.bind(this);
    }

    handleCancel() {
        const {closePanel, screen} = this.props;
        cancelChanged(screen);
        closePanel();
    }

    handleSave() {
        const {closePanel, screensStore} = this.props;
        saveData(screensStore, closePanel);
    }

    handleDefaults() {
        const {closePanel, screensStore} = this.props;
        restoreDefaultValues(screensStore, closePanel);
    }

    render() {
        return (
            <div className="panel-bottom">
                <Button
                    componentClasses="defaults-btn"
                    onClick={this.handleDefaults}
                    text={getLocalizedText(texts.defaults)}
                />
                <Button
                    componentClasses="cancel-btn"
                    onClick={this.handleCancel}
                    text={getLocalizedText(texts.cancel)}
                />
                <Button
                    componentClasses="confirm-btn"
                    onClick={this.handleSave}
                    img={checkMark}
                    alt={textConst.confirmAlt}
                    text={getLocalizedText(texts.save)}
                    labeled
                />
            </div>
        );
    }
}

@observer
export class DesignList extends Component<any, any> {
    constructor(props) {
        super(props);

        this.renderItem = this.renderItem.bind(this);
    }

    renderItem({item}) {
        return (
            <CollapsibleField field={item} renderParent={DesignField} renderChild={DesignField} />
        );
    }

    render() {
        const {screen} = this.props;
        return (
            <List
                className={screen.name === screenTypes.design.TREE ? 'painted' : ''}
                data={screen.collection.fields}
                keyExtractor={field => field.name}
                renderItem={this.renderItem}
            />
        );
    }
}

@observer
class DesignContent extends Component<any, any> {
    constructor(props) {
        super(props);

        this.newTab = this.newTab.bind(this);
        this.onToggleChange = this.onToggleChange.bind(this);
        this.selectSearchOption = this.selectSearchOption.bind(this);
    }

    newTab() {
        const {screen} = this.props;
        !disableNewTabBtn(screen) && createNewTab(screen);
    }

    onToggleChange() {
        const {screen} = this.props;
        changePicDesign(screen);
    }

    selectSearchOption(field) {
        selectScrollField(field);
    }

    renderTitle() {
        const {screen, isSplitted} = this.props;
        return isSplitted ? <div className="subscreen-title">{screen.title}</div> : null;
    }

    renderMovementsPanel() {
        const {screen} = this.props;
        return (
            <div>
                <Search
                    options={getLastLevelFields(screen)}
                    placeholder={
                        getLocalizedText(texts.search) +
                        ' ' +
                        (screen.entityName ? screen.entityName : '')
                    }
                    onOptionSelect={this.selectSearchOption}
                />
                {isMovementsPanelShown(screen) && <Movements field={screen.selected} />}
            </div>
        );
    }

    renderNewTabBtn() {
        const {screen} = this.props;
        return screen.name === screenTypes.design.TREE ? (
            <Button
                disabled={disableNewTabBtn(screen)}
                componentClasses="new-tab-btn"
                text={getLocalizedText(texts.newTab)}
                alt={textConst.plusAlt}
                onClick={this.newTab}
                labeled
            />
        ) : null;
    }

    showPicDesign() {
        const {screen} = this.props;
        return (
            screen.name === screenTypes.design.TREE && screen.picdesign && screen.picdesign !== '0'
        );
    }

    renderPicDesign() {
        const {screen} = this.props;
        return this.showPicDesign() ? (
            <div className="picdesign">
                <span>{getLocalizedText(texts.picdesign)}</span>
                <Checkbox
                    toggle
                    checked={screen.picdesign === activeCodes.ACTIVE}
                    onChange={this.onToggleChange}
                />
            </div>
        ) : null;
    }

    renderActionsMenu() {
        const {screen, open} = this.props;
        const {active, parentScreen} = screen;
        const actionsOpen =
            open &&
            active &&
            !active.isChanging &&
            (!parentScreen || parentScreen.active === screen.active);
        return <DesignActionsMenu open={actionsOpen} field={active} />;
    }

    renderList() {
        const {screen, isSplitted} = this.props;
        const movementsPanelShown = isMovementsPanelShown(screen);
        return (
            <div
                className={`list ${!this.showPicDesign() && !isSplitted && 'long'}
							${!movementsPanelShown && 'longer'}
							${!this.showPicDesign() && !movementsPanelShown && !isSplitted && 'longest'}`}
            >
                <div className="line" />
                <DesignList screen={screen} />
                {this.renderNewTabBtn()}
                {this.renderActionsMenu()}
            </div>
        );
    }

    render() {
        const {isSplitted} = this.props;
        return (
            <div className={`content ${isSplitted ? 'narrow' : ''}`}>
                {this.renderTitle()}
                {this.renderMovementsPanel()}
                {this.renderList()}
                {this.renderPicDesign()}
            </div>
        );
    }
}

export const Design = observer(props => {
    const {screen, closePanel, screensStore, open} = props;

    return (
        <div className="screen">
            {screen.isSplitted ? (
                <div className={`content-wrapper splitted`}>
                    {screen.screens.map(subscreen => (
                        <DesignContent
                            key={subscreen.name}
                            screen={subscreen}
                            open={open}
                            isSplitted
                        />
                    ))}
                </div>
            ) : (
                <div className={`content-wrapper`}>
                    <DesignContent screen={screen} open={open} />
                </div>
            )}
            <DesignBottom screen={screen} closePanel={closePanel} screensStore={screensStore} />
        </div>
    );
});

export default Design;
